module.exports = "/_next/static/images/JoshuaStewart-a01f8c540b229a014dffc82c7f3d1811.webp";